/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Board_DescInputs */

const en_directory_launch_board_desc = /** @type {(inputs: Directory_Launch_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh AI tools discovered this month.`)
};

const zh_directory_launch_board_desc = /** @type {(inputs: Directory_Launch_Board_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月新发现的高信号 AI 工具。`)
};

/**
* | output |
* | --- |
* | "Fresh AI tools discovered this month." |
*
* @param {Directory_Launch_Board_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_board_desc = /** @type {((inputs?: Directory_Launch_Board_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Board_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_board_desc(inputs)
	return zh_directory_launch_board_desc(inputs)
});
export { directory_launch_board_desc as "directory.launch.board_desc" }